import QTable from 'quasar/src/components/table/QTable.js';

export function getDepositColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'id',
      field: 'id',
      label: 'شناسه',
      align: 'center'
    },
    {
      name: 'title',
      field: 'title',
      label: 'عنوان واریز',
      align: 'left',
      style: 'max-width:200px;'
    },
    {
      name: 'payable_type',
      field: 'payable_type',
      label: 'نوع واریز',
      align: 'left'
    },
    {
      name: 'amount',
      field: 'amount',
      label: 'مقدار',
      align: 'center'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'تاریخ ایجاد',
      align: 'left'
    },
    {
      name: 'status',
      field: 'status',
      label: 'وضعیت',
      align: 'left'
    },
    {
      name: 'account_owner_name',
      field: 'account_owner_name',
      label: 'نام صاحب حساب',
      align: 'left',
      style: 'max-width:120px;'
    },
    {
      name: 'account_type',
      field: 'account_type',
      label: 'نوع حساب',
      align: 'left'
    },
    {
      name: 'sheba',
      field: 'sheba',
      label: 'شماره شبا',
      align: 'center'
    },
    {
      name: 'actions',
      field: 'actions',
      label: 'عملیات',
      align: 'center'
    }]
}